const ContactHero = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container-custom section-padding text-center">
        <div className="max-w-4xl mx-auto animate-fade-in">
          <h1 className="text-5xl lg:text-6xl font-light museo-font text-[#3a3a3a] mb-8">
            Hablemos de tu
            <span className="block text-[#ffb7b4] font-medium">próximo proyecto</span>
          </h1>
          
          <p className="text-xl text-[#3a3a3a]/80 leading-relaxed mb-12 max-w-3xl mx-auto">
            Estamos aquí para crear experiencias únicas que conecten tu marca 
            con audiencias exigentes a través de nuestro talento premium.
          </p>

          <div className="w-24 h-0.5 bg-[#ffb7b4] mx-auto"></div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;